import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface FilterBarContainerProps extends ComponentPropsWithoutRef<'div'> {}

const FilterBarContainer = (props: FilterBarContainerProps) => {
    const { className = '', children, ...rest } = props;
    return (
        <div
            className={twMerge(
                className,
                'flex flex-wrap items-center justify-between gap-x-12 gap-y-4 px-4 py-3 md:flex-nowrap',
            )}
            {...rest}
        >
            {children}
        </div>
    );
};

export { FilterBarContainer };
